import { defineMessages } from 'react-intl';

const upgradeRecommendationsMessages = defineMessages({
  featureName: {
    id: 'unlock.recommendations',
    defaultMessage: 'Recommendations',
  },
  featureHeading: {
    id: 'unlock.recommendations.heading',
    defaultMessage: 'Unlock Recommendations',
  },
  featureSummary: {
    id: 'unlock.recommendations.summary',
    defaultMessage: 'Make smarter and data driven decisions',
  },
  featureUnlockDetails: {
    id: 'unlock.recommendations.details',
    // eslint-disable-next-line max-len
    defaultMessage: 'We analyzed millions of application and student records to determine what makes a student more likely to enroll in your institution. Each high school is compared against the profile of past enrollees for your institution and scored on a scale of 1-100 (with 100 being the best and 50 as the median score). The score includes, but is not limited to, factors such as application history, type of high school, student career interest, religious affiliation, willingness to travel, student demographics, and town demographics. Recommendations is a list that shows the top high schools and their score based on this analysis.',
  },
});

export default upgradeRecommendationsMessages;
